/* Open a member's profile from anywhere (a name in the feed, a comment, a
   group, a mention) without threading a callback through every component. */
export function openProfile(handle) {
  if (handle) window.dispatchEvent(new CustomEvent('bn:profile', { detail: handle }));
}

/* Open Copilot on one of your files (e.g. a copy saved from a chat). */
export function askCopilotAbout(fileId) {
  if (fileId) window.dispatchEvent(new CustomEvent('bn:copilot-file', { detail: fileId }));
}
